import React from "react";
import { classNames } from "@bookingcom/bui-core/utilities/classNames";
import DismissibleContainer from "../DismissibleContainer/index.js";
import Stack from "../Stack/index.js";
import Text from "../Text/index.js";
import Flyout, {} from "../_base/Flyout/index.js";
import styles from "@bookingcom/bui-core/css/Popover.module.css";
var PopoverContext = React.createContext({});
var sizeMap = {
    small: "230px",
    medium: "360px",
    auto: "auto",
    stretch: "100%",
};
var Popover = function (props) {
    var id = props.id, forcePosition = props.forcePosition, onOpen = props.onOpen, onClose = props.onClose, lockClose = props.lockClose, active = props.active, defaultActive = props.defaultActive, children = props.children, zIndex = props.zIndex, fill = props.fill, trapFocusMode = props.trapFocusMode, navigationMode = props.navigationMode, _a = props.triggerType, triggerType = _a === void 0 ? "click" : _a, _b = props.position, position = _b === void 0 ? "bottom" : _b, disableAnimation = props.disableAnimation, keepMounted = props.keepMounted, triggerRef = props.triggerRef, containerRef = props.containerRef, positionRef = props.positionRef, onAfterOpen = props.onAfterOpen, onAfterClose = props.onAfterClose;
    var size = props.size || (position === "bottom-stretch" ? "stretch" : "medium");
    var sizeValue = sizeMap[size] || size;
    var flyoutRef = React.useRef(null);
    var contentClassName = classNames(styles.root, fill && styles["root--fill"], position && styles["root--position-".concat(position)]);
    var _c = React.useState(active === undefined ? !!defaultActive : !!active), localActive = _c[0], setLocalActive = _c[1];
    React.useEffect(function () {
        if (active === undefined)
            return;
        setLocalActive(!!active);
    }, [active]);
    var handleOpen = function () {
        if (active === undefined)
            setLocalActive(true);
        if (onOpen)
            return onOpen();
    };
    var handleClose = function () {
        if (lockClose)
            return;
        if (active === undefined)
            setLocalActive(false);
        if (onClose)
            return onClose();
    };
    return (React.createElement(PopoverContext.Provider, { value: { props: props, ref: flyoutRef } },
        React.createElement(Flyout, { id: id, position: position, forcePosition: forcePosition, onOpen: handleOpen, onClose: handleClose, onAfterOpen: onAfterOpen, onAfterClose: onAfterClose, trapFocusMode: trapFocusMode, navigationMode: navigationMode, triggerType: triggerType, active: localActive, contentClassName: contentClassName, contentAttributes: { style: { "--bui-popover-width": sizeValue } }, zIndex: zIndex, disableAnimation: disableAnimation, keepMounted: keepMounted, triggerRef: triggerRef, containerRef: containerRef, positionRef: positionRef, ref: flyoutRef }, children)));
};
var PopoverContent = function (props) {
    var children = props.children, title = props.title, attributes = props.attributes;
    var _a = React.useContext(PopoverContext), rootProps = _a.props, ref = _a.ref;
    var hideArrow = rootProps.hideArrow, lockClose = rootProps.lockClose, hideClose = rootProps.hideClose, closeAriaLabel = rootProps.closeAriaLabel, trapFocusMode = rootProps.trapFocusMode, triggerType = rootProps.triggerType, fill = rootProps.fill;
    var arrowClassName = classNames(styles.arrow, hideArrow && styles["arrow--hide"]);
    var handleClose = function () {
        if (lockClose)
            return;
        if (ref.current)
            ref.current.close();
    };
    var renderChildren = function () {
        var shouldHideClose = hideClose || triggerType === "hover" || trapFocusMode === "soft";
        var headingSlot = title && (React.createElement(Text, { className: styles.heading, variant: "strong_1" }, title));
        return (React.createElement(DismissibleContainer, { closeAriaLabel: closeAriaLabel, hideClose: shouldHideClose, onClose: handleClose, fill: fill },
            React.createElement(Stack, { gap: 2 },
                headingSlot,
                React.createElement(Stack.Item, null, children))));
    };
    return (React.createElement(Flyout.Content, { attributes: attributes },
        renderChildren(),
        React.createElement(Flyout.Arrow, { offset: 4, size: 7, background: "elevation_two", shadow: 100, className: arrowClassName })));
};
PopoverContent.displayName = "Popover.Content";
Popover.Content = PopoverContent;
Popover.Trigger = Flyout.Trigger;
Popover.Trigger.displayName = "Popover.Trigger";
export default Popover;
